/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Platinum_CtaInputs */

const en_pricing_platinum_cta = /** @type {(inputs: Pricing_Platinum_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go Platinum`)
};

const es_pricing_platinum_cta = /** @type {(inputs: Pricing_Platinum_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertirse en Platinum`)
};

const fr_pricing_platinum_cta = /** @type {(inputs: Pricing_Platinum_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devenir Platinum`)
};

const de_pricing_platinum_cta = /** @type {(inputs: Pricing_Platinum_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platinum werden`)
};

const id_pricing_platinum_cta = /** @type {(inputs: Pricing_Platinum_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadi Platinum`)
};

/** @type {(inputs: Pricing_Platinum_CtaInputs) => LocalizedString} */
const ja_pricing_platinum_cta = en_pricing_platinum_cta;

/** @type {(inputs: Pricing_Platinum_CtaInputs) => LocalizedString} */
const zh_pricing_platinum_cta = en_pricing_platinum_cta;

/** @type {(inputs: Pricing_Platinum_CtaInputs) => LocalizedString} */
const ar_pricing_platinum_cta = en_pricing_platinum_cta;

/** @type {(inputs: Pricing_Platinum_CtaInputs) => LocalizedString} */
const it_pricing_platinum_cta = en_pricing_platinum_cta;

/** @type {(inputs: Pricing_Platinum_CtaInputs) => LocalizedString} */
const ru_pricing_platinum_cta = en_pricing_platinum_cta;

/** @type {(inputs: Pricing_Platinum_CtaInputs) => LocalizedString} */
const pt_pricing_platinum_cta = en_pricing_platinum_cta;

/** @type {(inputs: Pricing_Platinum_CtaInputs) => LocalizedString} */
const ko_pricing_platinum_cta = en_pricing_platinum_cta;

/**
* | output |
* | --- |
* | "Go Platinum" |
*
* @param {Pricing_Platinum_CtaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_platinum_cta = /** @type {((inputs?: Pricing_Platinum_CtaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Platinum_CtaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_platinum_cta(inputs)
	if (locale === "es") return es_pricing_platinum_cta(inputs)
	if (locale === "fr") return fr_pricing_platinum_cta(inputs)
	if (locale === "de") return de_pricing_platinum_cta(inputs)
	if (locale === "ja") return ja_pricing_platinum_cta(inputs)
	if (locale === "zh") return zh_pricing_platinum_cta(inputs)
	if (locale === "ar") return ar_pricing_platinum_cta(inputs)
	if (locale === "id") return id_pricing_platinum_cta(inputs)
	if (locale === "it") return it_pricing_platinum_cta(inputs)
	if (locale === "ru") return ru_pricing_platinum_cta(inputs)
	if (locale === "pt") return pt_pricing_platinum_cta(inputs)
	return ko_pricing_platinum_cta(inputs)
});